module.exports = __webpack_public_path__ + "static/img/pay-icon04.9db8f27a.svg";